<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
// import HelloWorld from './views/landing.vue'

// Selector for every "button" we want to keep in English when the Google
// Translate widget runs: native <button>, Vuetify .v-btn, role="button",
// input buttons, and link-style buttons (any class containing "btn").
const BUTTON_SELECTOR =
  'button, .v-btn, [role="button"], input[type="button"], input[type="submit"], input[type="reset"], [class*="btn"], [class*="Btn"]';

function markNoTranslate(el) {
  if (el && el.nodeType === 1 && !el.hasAttribute("translate")) {
    el.setAttribute("translate", "no");
    el.classList.add("notranslate");
  }
}

function sweepButtons(root) {
  try {
    const r = root || document;
    if (r.nodeType === 1 && r.matches && r.matches(BUTTON_SELECTOR)) markNoTranslate(r);
    if (r.querySelectorAll) {
      const nodes = r.querySelectorAll(BUTTON_SELECTOR);
      for (let i = 0; i < nodes.length; i++) markNoTranslate(nodes[i]);
    }
  } catch (e) {
    /* ignore */
  }
}

export default {
  name: "App",
  mounted() {
    // Tag everything already rendered, then keep tagging anything added later
    // (route changes, dialogs, dynamically rendered lists) before Google
    // Translate can translate it.
    sweepButtons(document);
    try {
      this._noTranslateObserver = new MutationObserver((muts) => {
        for (let i = 0; i < muts.length; i++) {
          const added = muts[i].addedNodes;
          for (let j = 0; j < added.length; j++) sweepButtons(added[j]);
        }
      });
      this._noTranslateObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    } catch (e) {
      /* ignore */
    }
  },
  beforeUnmount() {
    if (this._noTranslateObserver) this._noTranslateObserver.disconnect();
  },
};
</script>

<style>
* {
  font-family: 'Poppins', sans-serif !important;
}

body {
  font-family: 'Poppins', sans-serif !important;
}

#app {
  font-family: 'Poppins', sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Override Vuetify default fonts */
.v-application {
  font-family: 'Poppins', sans-serif !important;
}

.v-application .text-h1,
.v-application .text-h2,
.v-application .text-h3,
.v-application .text-h4,
.v-application .text-h5,
.v-application .text-h6,
.v-application .text-subtitle-1,
.v-application .text-subtitle-2,
.v-application .text-body-1,
.v-application .text-body-2,
.v-application .text-button,
.v-application .text-caption,
.v-application .text-overline {
  font-family: 'Poppins', sans-serif !important;
}
</style>
